module.exports = __webpack_public_path__ + "static/media/layout-3.b0e88c67.svg";